// Language translations for PTPA website
export const translations = {
  EN: {
    // Navigation
    nav: {
      home: "Home",
      about: "About Us",
      committee: "Committee",
      members: "Members",
      events: "Events",
      gallery: "Gallery",
      blogs: "Blogs"
    },

    // Home Page
    home: {
      title: "Pandikkad Town Pravasi Association",
      subtitle: "A Global Community Connecting Pandikkad's Diaspora",
      totalMembers: "Total Members",
      workingAbroad: "Working Abroad",
      inPandikkad: "In Pandikkad",
      founded: "Founded",
      aboutTitle: "About PTPA",
      aboutText1: "The Pandikkad Town Pravasi Association (PTPA) is a vibrant community of 238 members, primarily comprising expatriates from Pandikkad town and surrounding areas. Our association was established in 2019 to bring together individuals living abroad while maintaining strong ties with our hometown.",
      aboutText2: "With 188 of our members currently working outside the country and the remaining 50 members settled, retired, or residing in Pandikkad, we serve as a bridge connecting our global community and preserving the cultural bonds that unite us.",
      learnMore: "Learn More",
      meetLeaders: "Meet Our Leaders",
      meetLeadersText: "Our dedicated leadership team working to strengthen our community",
      committee: "Committee",
      committeeText: "Meet our 17-member leadership team",
      membersDir: "Members Directory",
      membersDirText: "Connect with our community members",
      eventsSection: "Events",
      eventsText: "Upcoming gatherings and celebrations",
      gallery: "Gallery",
      galleryText: "Photo memories of our community"
    },

    // About Us Page
    about: {
      title: "About PTPA",
      subtitle: "Pandikkad Town Pravasi Association",
      whoWeAre: "Who We Are",
      whoWeAreText: "The Pandikkad Town Pravasi Association (PTPA) is a vibrant, inclusive community that connects expatriates and residents of Pandikkad town from around the globe. Founded in 2019, PTPA has grown into a family of 238 dedicated members, all united by their shared roots in Pandikkad.\n\nOur association serves as a bridge between those working internationally and our hometown, fostering cultural ties and mutual support among members of our diaspora.",
      ourCommunity: "Our Community",
      ourMission: "Our Mission",
      missionText: "To create a strong, supportive network that:",
      missionPoints: [
        "Connects expatriates and residents of Pandikkad across the globe",
        "Preserves and celebrates our cultural heritage and traditions",
        "Provides mutual support and community assistance",
        "Organizes social events and family gatherings",
        "Strengthens bonds between generations and geographical distances",
        "Facilitates knowledge sharing and professional networking"
      ],
      whatWeDo: "What We Do",
      events: "📅 Events & Gatherings",
      eventsDesc: "Organize family celebrations, reunions, and cultural events",
      support: "🤝 Community Support",
      supportDesc: "Provide assistance and support to members in need",
      global: "🌍 Global Connection",
      globalDesc: "Bridge the gap between diaspora members worldwide",
      memory: "📸 Memory Sharing",
      memoryDesc: "Create and share memorable moments through our gallery",
      professional: "💼 Professional Network",
      professionalDesc: "Facilitate professional connections and opportunities",
      knowledge: "🎓 Knowledge Exchange",
      knowledgeDesc: "Share experiences and expertise among members",
      whyJoin: "Why Join PTPA",
      stayConnected: "Stay Connected",
      stayConnectedDesc: "Maintain meaningful connections with friends and family from Pandikkad",
      cultural: "Cultural Continuity",
      culturalDesc: "Preserve our traditions and pass them on to younger generations",
      supportNetwork: "Support Network",
      supportNetworkDesc: "Be part of a community that cares and supports each other",
      exclusiveEvents: "Exclusive Events",
      exclusiveEventsDesc: "Participate in special gatherings and celebrations planned for members",
      growth: "Professional Growth",
      growthDesc: "Expand your professional network and find new opportunities",
      shared: "Shared Heritage",
      sharedDesc: "Celebrate our common roots and hometown pride"
    },

    // Committee Page
    committee: {
      title: "Committee Members",
      subtitle: "Meet the 17-member leadership team of PTPA",
      leadership: "Leadership Structure",
      leadershipText: "Our 17-member committee consists of dedicated individuals who volunteer their time and expertise to serve the PTPA community. The committee is responsible for:",
      responsibilities: [
        "Planning and organizing community events",
        "Managing membership and communications",
        "Financial management and resource allocation",
        "Cultural preservation and celebrations",
        "Member welfare and support programs",
        "Expanding our community and network"
      ]
    },

    // Members Page
    members: {
      title: "Members Directory",
      subtitle: "Connect with our community members from around the world",
      search: "Search by name or profession...",
      filterBy: "Filter by Location:",
      showing: "Showing",
      of: "of",
      members: "members",
      noResults: "No members found matching your search criteria.",
      resetFilters: "Reset Filters",
      overview: "Community Overview",
      overviewText: "Our membership includes professionals from various fields working across the globe. This directory showcases a sample of our community. For the complete member list, please contact our membership officer.",
      international: "International",
      inIndia: "In India",
      countries: "Countries"
    },

    // Events Page
    events: {
      title: "Events & Gatherings",
      subtitle: "Join us for memorable celebrations and community gatherings",
      upcoming: "Upcoming Events",
      learnMore: "Learn More",
      pastHighlights: "Past Events Highlights",
      types: "Types of Events We Organize",
      celebrations: "🎉 Celebrations",
      celebrationsDesc: "Annual reunions, festivals, and milestone celebrations",
      professional: "💼 Professional Events",
      professionalDesc: "Networking sessions and career development workshops",
      educational: "🎓 Educational Programs",
      educationalDesc: "Seminars and training sessions for members and youth",
      social: "🤝 Social Gatherings",
      socialDesc: "Casual meetups and family bonding activities",
      community: "🎗️ Community Service",
      communityDesc: "Charity drives and welfare activities",
      cultural: "🌍 Cultural Programs",
      culturalDesc: "Heritage preservation and cultural awareness activities"
    },

    // Gallery Page
    gallery: {
      title: "Photo Gallery",
      subtitle: "Precious moments and memories of our community",
      intro: "Browse through our collection of photos from various PTPA events and gatherings. These images capture the spirit of our community and the bonds we share.",
      share: "Share Your Memories",
      shareText: "Do you have photos from PTPA events that you'd like to share? We'd love to feature your pictures in our gallery. Please send your high-quality photos to our team. Help us preserve and celebrate our community's precious moments!",
      email: "Email:",
      whatsapp: "WhatsApp:",
      categories: "Gallery Categories",
      eventsGallery: "🎉 Events & Celebrations",
      eventsGalleryDesc: "Memorable moments from our annual reunions and festivities",
      family: "👨‍👩‍👧‍👦 Family Gatherings",
      familyDesc: "Family bonding and recreational activities",
      culturalProgs: "🌍 Cultural Programs",
      culturalProgsDesc: "Heritage preservation and cultural awareness activities",
      youthProgs: "🎓 Youth Programs",
      youthProgsDesc: "Leadership development and youth empowerment initiatives",
      communityServ: "🤝 Community Service",
      communityServDesc: "Charity and welfare activities benefiting the community",
      heritage: "🏠 Pandikkad Heritage",
      heritageDesc: "Images celebrating our hometown and heritage"
    },

    // Blogs Page
    blogs: {
      title: "Community Blogs",
      subtitle: "Share your stories and insights with our community",
      noBlogsMessage: "Currently no blogs published yet",
      submitMessage: "We would love to feature your articles, stories, and insights! Share your experiences and knowledge with our PTPA community.",
      sendBlogs: "Send Your Blogs",
      contactInfo: "Contact Information:",
      email: "Email: roshan@codeecom.in",
      whatsapp: "WhatsApp: +919778256046",
      guidelinesTitle: "Submission Guidelines",
      guidelinesText: "We welcome blogs related to PTPA, community stories, cultural insights, professional experiences, and life lessons. Please send your articles in text format or as attachments."
    }
  },

  ML: {
    // Navigation
    nav: {
    home: "ഹോം",
      about: "PTPA യെ കുറിച്ച്",
      committee: "കമ്മിറ്റി",
      members: "അംഗങ്ങൾ",
      events: "ഇവൻ്റുകൾ",
      gallery: "ഗാലറി",
      blogs: "ബ്ലോഗുകൾ"
    },

    // Home Page
    home: {
      title: "പാണ്ടിക്കാട് ടൗൺ പ്രവാസി അസോസിയേഷൻ",
      subtitle: "പാണ്ടിക്കാടിൻ്റെ പ്രവാസ സമൂഹത്തിനായുള്ള ആഗോള വേദി",
      totalMembers: "മൊത്തം അംഗങ്ങൾ",
      workingAbroad: "വിദേശത്ത് പ്രവർത്തിക്കുന്നവർ",
      inPandikkad: "പാണ്ടിക്കാടിൽ",
      founded: "സ്ഥാപിതം",
      aboutTitle: "PTPA യെ കുറിച്ച്",
      aboutText1: "പാണ്ടിക്കാട് ടൗൺ പ്രവാസി അസോസിയേഷൻ (PTPA) പാണ്ടിക്കാട് ടൗൺ നാഗരിക വിഷയങ്ങൾ, 238 അംഗങ്ങളോടുകൂടിയ സജീവമായ കൂട്ടായ്മയാണ്. 2019 ൽ സ്ഥാപിതമായ ഈ കൂട്ടായ്മ പ്രവാസികളും മുൻ പ്രവാസികളുമായ പാണ്ടിക്കാട്ടുകാരെ ഒരുമിച്ചു കൊണ്ടുവരാനും നാടിനോട് ശക്തമായ ബന്ധം നിലനിർത്താനും ഉദ്ദേശിച്ചിട്ടുള്ളതാണ്.",
      aboutText2: "ഈ കൂട്ടായ്മയിലെ 188 അംഗങ്ങൾ നിലവിൽ വിദേശത്തും ബാക്കി 50 അംഗങ്ങൾ നാട്ടിലും പ്രവർത്തിക്കുന്നവരോ വിരമിച്ചവരോ ആണ്. ഞങ്ങൾ നമ്മുടെ ഗ്ലോബൽ കമ്യൂണിറ്റിയെ ബന്ധിപ്പിക്കുന്നതിനും ഞങ്ങളെ ഐക്യപ്പെടുത്തുന്ന സാംസ്കൃതിക ബന്ധങ്ങൾ സംരക്ഷിക്കുന്നതിനും  ഒരുമിച്ച് പ്രവർത്തിക്കുന്നു.",
      learnMore: "കൂടുതൽ അറിയാൻ",
      meetLeaders: "PTPA യെ നയിക്കുന്നവർ",
      meetLeadersText: "നമ്മുടെ കൂട്ടായ്മയെ ശക്തിപ്പെടുത്താൻ പ്രതിബദ്ധരായ നമ്മുടെ നിയുക്ത നേതൃത്വ ടീം",
      committee: "കമ്മിറ്റി",
      committeeText: "ഞങ്ങളുടെ 17 അംഗ നേതൃത്വ കമ്മിറ്റി",
      membersDir: "അംഗങ്ങളുടെ ഡയറക്ടറി",
      membersDirText: "ഞങ്ങളുടെ കമ്യൂണിറ്റി അംഗങ്ങളുമായി ബന്ധിപ്പിക്കുക",
      eventsSection: "ഇവൻ്റുകൾ", 
      eventsText: "വരാനിരിക്കുന്ന സമ്മേളനങ്ങളും മറ്റു പരിപാടികളും",
      gallery: "ഗാലറി",
      galleryText: "പ്രവാസി കൂട്ടായ്മയുടെ ഫോട്ടോ കളക്ഷൻ"
    },

    // About Us Page
    about: {
      title: "PTPA യെ കുറിച്ച്",
      subtitle: "പാണ്ടിക്കാട് ടൗൺ പ്രവാസി അസോസിയേഷൻ",
      whoWeAre: "PTPA ആരാണ്",
      whoWeAreText: "പാണ്ടിക്കാട് ടൗൺ പ്രവാസി അസോസിയേഷൻ (PTPA) പാണ്ടിക്കാട് അങ്ങാടി നിവാസികളായ പ്രവാസികളെയും, മുൻ പ്രവാസികളെയും ലോകമെമ്പാടും ബന്ധിപ്പിക്കുന്ന ഒരു സജീവമായ വാട്സാപ്പ് കൂട്ടായ്മയാണ്. 2019 ൽ സ്ഥാപിതമായ PTPA, 238 അംഗങ്ങളുള്ള കുടുംബമായി വളർന്നു, എല്ലാവരും പാണ്ടിക്കാടിലെ പൊതുവായ വേരുകളാൽ ഐക്യപ്പെട്ടു.",
      ourCommunity: "ഞങ്ങളുടെ കൂട്ടായ്മ",
      ourMission: "ഞങ്ങളുടെ ലക്ഷ്യം",
      missionText: "ഇനിപ്പറയുന്ന കാര്യങ്ങൾ നടത്തുവാൻ ശക്തിയേറിയ സഹായകമായ നെറ്റ്‌വർക്ക്  സൃഷ്ടിക്കുക:",
      missionPoints: [
        "പാണ്ടിക്കാടിൻ്റെ പ്രവാസികളെയും സ്ഥിരതാമസമാക്കിയ മുൻ പ്രവാസികളെയും  ലോകമെമ്പാടും ബന്ധിപ്പിക്കുക",
        "ഞങ്ങളുടെ സാംസ്കൃതിക പാരമ്പര്യവും ആചാരങ്ങളും സംരക്ഷിച്ച് ആഘോഷിക്കുക",
        "പരസ്പര സഹായം നൽകുവാനും കമ്യൂണിറ്റി സഹായം പ്രദാനം ചെയ്യുവാനും",
        "പാരിവാരിക ആഘോഷങ്ങളും സമ്മേളനങ്ങളും സംഘടിപ്പിക്കുക",
        " ബന്ധങ്ങൾ ശക്തിപ്പെടുത്തുക",
        "ഞങ്ങൾ അറിവുകൾ വിനിമയം ചെയ്യുവാനും പ്രൊഫഷണൽ നെറ്റ്‌വർക്കിങ്ങ് സുഗമമാക്കുവാനും"
      ],
      whatWeDo: "നാം എന്താണ് ചെയ്യുന്നത്",
      events: "📅 ഇവൻ്റുകൾ & സമ്മേളനങ്ങൾ",
      eventsDesc: "കുടുംബ ആഘോഷങ്ങൾ, പുനഃ സംയോഗങ്ങൾ, സാംസ്കൃതിക ഇവൻ്റുകൾ സംഘടിപ്പിക്കുക",
      support: "🤝 കമ്യൂണിറ്റി സപ്പോർട്ട്",
      supportDesc: "ആവശ്യമുള്ള അംഗങ്ങൾക്ക് സഹായവും പിന്തുണയും നൽകുക",
      global: "🌍 ആഗ്ലോബൽ ബന്ധം",
      globalDesc: "ലോകമെമ്പാടുള്ള പ്രവാസ അംഗങ്ങൾക്കിടയെ വിഭജിത ഭാഗങ്ങൾ നികത്തുക",
      memory: "📸 സ്മരണ വിനിമയം",
      memoryDesc: "ഞങ്ങളുടെ ഗാലറി വിലൂപമായ നിമിഷങ്ങൾ സൃഷ്ടിക്കുവാനും പങ്കുവെയ്ക്കുവാനും",
      professional: "💼 പ്രൊഫഷണൽ നെറ്റ്-വർക്ക്",
      professionalDesc: "പ്രൊഫഷണൽ ബന്ധങ്ങൾ സുഗമമാക്കുവാനും സ്ഥാപിത സാധ്യതകൾ അറിയിക്കുവാനും",
      knowledge: "🎓 അറിവുകൾ വിനിമയം",
      knowledgeDesc: "അംഗങ്ങൾ പരാമർശങ്ങൾ പങ്കുവെയ്ക്കുവാനും വിദ്യ പങ്കുവെയ്ക്കുവാനും",
      whyJoin: "PTPA യിൽ അംഗമാകുന്നതിന് കാരണമെന്തായിരിക്കും",
      stayConnected: "ബന്ധിപ്പിച്ച് നിൽക്കുക",
      stayConnectedDesc: "പാണ്ടിക്കാടിൽ നിന്നുള്ള സ്നേഹിതരുമായും കുടുംബ അംഗങ്ങൾക്കുമായുള്ള അർത്ഥവത്തായ ബന്ധങ്ങൾ നിലനിർത്തുക",
      cultural: "സാംസ്കൃതിക തുടർച്ച",
      culturalDesc: "ഞങ്ങളുടെ ആചാരങ്ങൾ സംരക്ഷിച്ച് അടുത്ത തലമുറയിലേയ്ക്ക് കൈമാറുക",
      supportNetwork: "സഹായ നെറ്റ്വർക്ക്",
      supportNetworkDesc: "പരിചരണം ചെയ്യുന്ന കമ്യൂണിറ്റിയുടെ ഭാഗമായ് നിൽക്കുക",
      exclusiveEvents: "എക്സക്ലൂസിവ് ഇവന്റുകൾ",
      exclusiveEventsDesc: "അംഗങ്ങൾക്കായി ആസൂത്രിത പ്രത്യേക സമ്മേളനങ്ങളും ആഘോഷങ്ങളിലും പങ്കെടുക്കുക",
      growth: "പ്രൊഫ് വികാസം",
      growthDesc: "നിങ്ങളുടെ പ്രൊഫ് നെറ്റ്വർക്ക് സ്ഥാപിത ചെയ്യുവാനും പുതിയ സാധ്യതകൾ കണ്ടെത്തുവാനും",
      shared: "പങ്കുവെയ്ച്ചുള്ള പാരമ്പര്യം",
      sharedDesc: "ഞങ്ങളുടെ പൊതുവായ വേരുകൾ, നാട്ടിന് പ്രതി അഭിമാനം ആഘോഷിക്കുക"
    },

    // Committee Page
    committee: {
      title: "കമ്മിറ്റി അംഗങ്ങൾ",
      subtitle: "PTPA യുടെ 17 അംഗ നേതൃത്വ ടീമുമായി കൂടിക്കാഴ്ച്ച ചെയ്യുക",
      leadership: "നേതൃത്വ ഘടന",
      leadershipText: "ഞങ്ങളുടെ 17 അംഗ കമ്മിറ്റി PTPA കമ്യൂണിറ്റിയെ സേവിക്കാൻ തൊഴിൽ സമയം അധികാരങ്ങൾ നിക്ഷിപ്ത കരുതൽ വ്യക്തികളെ    അടങ്ങിയിരിക്കുന്നു. കമ്മിറ്റി കാര്യങ്ങൾ ചെയ്യാൻ കർത്തവ്യമുള്ളത്:",
      responsibilities: [
        "കമ്യൂണിറ്റി ഇവൻറുകൾ ആസൂത്രണം ചെയ്യുവാനും സംഘടിപ്പിക്കുവാനും",
        "സാങ്കേതിക വിദ്യ നിർവ്വഹണവും ആശയവിനിമയവും കൈകാര്യം ചെയ്യുക",
        "സാമ്പത്തിക നിരയ സ്ഥാപിത വിതരണവും നിർവഹണവും",
        "സാംസ്കൃതിക സംരക്ഷണും ആഘോഷങ്ങളും",
        "സാങ്കേതിക വിദ്യ കപന്നപ്രോഗ്രാമുകൾ",
        "നമ്മുടെ കമ്യൂണിറ്റിയും നെറ്റ്വർക്കും വിസ്തരിപ്പിക്കുക"
      ]
    },

    // Members Page
    members: {
      title: "അംഗങ്ങൾ ഡയറക്ടറി",
      subtitle: "ലോകമെമ്പാടുള്ള PTPA അംഗങ്ങളുമായി ബന്ധിപ്പിക്കുക",
      search: "പേരോ തൊഴിലോ നൽകി തിരയുക...",
      filterBy: "റീജിയൺ പ്രകാരം ഫിൽട്ടർ ചെയ്യുക:",
      showing: "കാണിക്കുന്നു",
      of: "- ലെ",
      members: "അംഗങ്ങളെ",
      noResults: "നിങ്ങളുടെ തിരയൽ മാനദണ്ഡവുമായി പൊരുത്തപ്പെടുന്ന അംഗങ്ങൾ ഇല്ല.",
      resetFilters: "ഫിൽട്ടറുകൾ പുനഃസജ്ജീകരിക്കുക",
      overview: "കമ്യൂണിറ്റി അവലോകനം",
      overviewText: "നമ്മുടെ അംഗങ്ങൾ വിവിധ മേഖലകളിൽ പ്രൊഫഷണലുകൾ കൂടാതെ ലോകമെമ്പാടും പ്രവർത്തിക്കുന്നു. ഈ ഡയറക്ടറി നമ്മുടെ കമ്യൂണിറ്റിയുടെ സാമ്പിൾ പ്രദർശിപ്പിക്കുന്നു. സമ്പൂർണ അംഗ ലിസ്റ്റിനായി, ദയവായി നമ്മുടെ അംഗ ഓഫീസറുമായി ബന്ധപ്പെടുക.",
      international: "അന്തർരാജ്യ",
      inIndia: "ഇന്ത്യയിൽ",
      countries: "രാജ്യങ്ങൾ"
    },

    // Events Page
    events: {
      title: "ഇവൻറുകൾ & സമ്മേളനങ്ങൾ",
      subtitle: "അവിസ്മരണീയ ആഘോഷങ്ങളും കമ്യൂണിറ്റി സമ്മേളനങ്ങളുമായി ഞങ്ങൾക്ക് ചേരുക",
      upcoming: "വരാനിരിക്കുന്ന ഇവൻറുകൾ",
      learnMore: "കൂടുതല് അറിയുക",
      pastHighlights: "മുൻ ഇവൻറുകളുടെ ഹൈലൈറ്റുകൾ",
      types: "നാം സംഘടിപ്പിക്കുന്ന ഇവൻറുകളുടെ തരങ്ങൾ",
      celebrations: "🎉 ആഘോഷങ്ങൾ",
      celebrationsDesc: "വാർഷികമായ പുനഃ സംയോഗങ്ങൾ, ആഘോഷങ്ങൾ, നിമിഷ സംരക്ഷണ ആഘോഷങ്ങൾ",
      professional: "💼 പ്രൊഫഷണൽ ഇവൻറുകൾ",
      professionalDesc: "നെറ്റ്-വർക്കിങ് സെഷൻസ്, കരിയർ ഗൈഡൻസ്",
      educational: "🎓 വിദ്യാ പ്രോഗ്രാമുകൾ",
      educationalDesc: "അംഗങ്ങൾക്കും യുവാക്കൾക്കും സെമിനാറുകൾ, പരീക്ഷണ സെഷനുകൾ",
      social: "🤝 സാമൂഹിക സമ്മേളനങ്ങൾ",
      socialDesc: "സാധാരണ കൂടികളായ് കുടുംബ ബന്ധിത ഗതിവിധികൾ",
      community: "🎗️ കമ്യൂണിറ്റി സേവനം",
      communityDesc: "ദാരിദ്ര പ്രേരണകൾ, സുഖ സാധന പ്രവർത്തനങ്ങൾ",
      cultural: "🌍 സാംസ്കൃതിക പ്രോഗ്രാമുകൾ",
      culturalDesc: "പാരമ്പര്യ സംരക്ഷണ, സാംസ്കൃതിക ബോധാവബോധ വിദ്യാ"
    },

    // Gallery Page
    gallery: {
      title: "ഫോട്ടോ ഗാലറി",
      subtitle: "PTPA കമ്യൂണിറ്റിയുടെ അമൂല്യമായ നിമിഷങ്ങളും സ്മരണകളും",
      intro: "വിവിധ PTPA ഇവൻറുകളും സമ്മേളനങ്ങളിൽ നിന്നും നമ്മുടെ ഫോട്ടോ സംഗ്രഹത്തിലൂടെ പരിശ്രമിക്കുക. ഈ ചിത്രങ്ങൾ നമ്മുടെ കമ്യൂണിറ്റിയുടെ ആത്മാവും ഞങ്ങളെ ബന്ധിപ്പിക്കുന്ന ബന്ധങ്ങളും ക്യാപ്ചർ ചെയ്യുന്നു.",
      share: "നിങ്ങളുടെ സ്മരണകൾ പങ്കുവെയ്ക്കുക",
      shareText: "നിങ്ങൾക്ക് PTPA ഇവൻറുകളിൽ നിന്നും ഫോട്ടോകൾ പങ്കുവെയ്ക്കാൻ ആഗ്രഹിക്കുന്നുണ്ടോ? നമ്മുടെ ഗാലറിയിൽ നിങ്ങളുടെ ചിത്രങ്ങൾ പ്രദർശിപ്പിക്കാൻ ഞങ്ങൾ തിരഞ്ഞെടുക്കുന്നു. ദയവായി നിങ്ങളുടെ ഫോട്ടോകൾ PTPA ടീമുമായി പങ്കുവെയ്ക്കുക. നമ്മുടെ കൂട്ടായ്മയുടെ അമൂല്യ നിമിഷങ്ങൾ സംരക്ഷിക്കുവാനും ആഘോഷിക്കുവാനും സാധ്യമാക്കുക!",
      email: "ഇമെയിൽ:",
      whatsapp: "വാട്സ്ആപ്പ്:",
      categories: "ഗാലറി വിഭാഗങ്ങൾ",
      eventsGallery: "🎉 ഇവന്റുകൾ & ആഘോഷങ്ങൾ",
      eventsGalleryDesc: "നമ്മുടെ വാർഷികമായ പുനഃ സംയോഗങ്ങളും ഉത്സവങ്ങളും അവിസ്മരണീയ നിമിഷങ്ങൾ",
      family: "👨‍👩‍👧‍👦 കുടുംബ സമ്മേളനങ്ങൾ",
      familyDesc: "കുടുംബ ബന്ധിത ഗതിവിധികൾ, വിനോദ ഗതിവിധികൾ",
      culturalProgs: "🌍 സാംസ്കൃതിക പ്രോഗ്രാമുകൾ",
      culturalProgsDesc: "പാരമ്പര്യ സംരക്ഷണ, സാംസ്കൃതിക ബോധാവബോധ വിദ്യാ",
      youthProgs: "🎓 യുവ പ്രോഗ്രാമുകൾ",
      youthProgsDesc: "നേതൃത്വ വികാസ, യുവാ ക്ഷമതാ പ്രകടനം പ്രാരംഭങ്ങൾ",
      communityServ: "🤝 കമ്യൂണിറ്റി സേവനം",
      communityServDesc: "കമ്യൂണിറ്റിയെ സന്തുഷ്ടരാക്കുന്ന ദാരിദ്ര, സുഖ സാധന പ്രവർത്തനങ്ങൾ",
      heritage: "🏠 പാണ്ടിക്കാട് പാരമ്പര്യം",
      heritageDesc: "നമ്മുടെ പരിമിതി വിജാതീതം ആഘോഷിക്കുന്നവ ചിത്രങ്ങൾ"
    },

    // Blogs Page
    blogs: {
      title: "കമ്മ്യൂണിറ്റി ബ്ലോഗുകൾ",
      subtitle: "പ്രവാസ ജീവിതത്തിലെ അനുഭവങ്ങളും, കഥകളും, ഉൾക്കാഴ്ചകളും പ്രവാസി കൂട്ടായ്മയുമായി പങ്കുവെയ്ക്കുക",
      noBlogsMessage: "നിലവിൽ ബ്ലോഗുകൾ പ്രസിദ്ധീകരിച്ചിട്ടില്ല",
      submitMessage: "നിങ്ങളുടെ ലേഖനങ്ങൾ, അനുഭവങ്ങൾ, കഥകൾ, ഉൾക്കാഴ്ചകൾ പ്രകാശിപ്പിക്കാൻ ഞങ്ങൾ ആഗ്രഹിക്കുന്നു! നിങ്ങളുടെ അനുഭവങ്ങളും അറിവും ഞങ്ങളുടെ PTPA കൂട്ടായ്മയുമായി പങ്കുവെയ്ക്കുക.",
      sendBlogs: "ബ്ലോഗുകൾ പങ്കുവെയ്ക്കാൻ",
      contactInfo: "ബന്ധപ്പെടുക :",
      email: "ഇമെയിൽ: roshan@codeecom.in",
      whatsapp: "വാട്സ്ആപ്പ്: +919778256046",
      guidelinesTitle: "സമർപ്പണ നിർദേശങ്ങൾ",
      guidelinesText: "PTPA-യെ സംബന്ധിച്ച ബ്ലോഗുകൾ, കമ്മ്യൂണിറ്റി കഥകൾ, സാംസ്കൃതിക ഉൾക്കാഴ്ചകൾ, പ്രൊഫഷണൽ അനുഭവങ്ങൾ, ജീവിത പാഠങ്ങൾ തുടങ്ങിയവ ഞങ്ങൾ സ്വാഗതം ചെയ്യുന്നു. ദയവായി നിങ്ങളുടെ ലേഖനങ്ങൾ ടെക്സ്റ്റ് ഫോർമാറ്റിൽ അല്ലെങ്കിൽ അറ്റാച്ച്മെൻറായി അയയ്ക്കുക."
    }
  }
};
